import Vue from 'vue'
/**
 * 拦截重复请求的自定义命令
 */
// 自定义指令防止按钮重复点击 v-preventReClick(使用时)
const preventReClick = Vue.directive('preventReClick', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      const dom = el
      if (!el.disabled) {
        dom.disabled = true
        dom.style.opacity = '0.5'
        dom.style.cursor = 'not-allowed'
        setTimeout(() => {
          dom.disabled = false
          dom.style.opacity = '1'
          dom.style.cursor = ''
        }, binding.value || 3000)
      }
    })
  },
})
export default {
  preventReClick,
}
